<template>
  <div id="appMenubar" class="container" style="margin:0 auto; text-align:center; padding-top:5px;">
    <el-button-group>
      <el-button
        size="mini"
        :type="isBtn1 ? 'primary' : ''"
        :disabled="isBtn1 ? true : false"
        plain
        @click.prevent="fnLink('/')"
      >BINANCE</el-button>
      <el-button
        size="mini"
        :type="isBtn2 ? 'primary' : ''"
        :disabled="isBtn2 ? true : false"
        plain
        @click.prevent="fnLink('/bitfinex')"
      >BITFINEX</el-button>
      <el-button
        size="mini"
        :type="isBtn3 ? 'primary' : ''"
        :disabled="isBtn3 ? true : false"
        plain
        @click.prevent="fnLink('/upbit_krw')"
      >UPBIT</el-button>
      <el-button
        size="mini"
        :type="isBtn4 ? 'primary' : ''"
        :disabled="isBtn4 ? true : false"
        plain
        @click.prevent="fnLink('/upbit_btc')"
      >UPBIT BTC</el-button>
      <br />
      <el-button
        size="mini"
        :type="isBtn11 ? 'primary' : ''"
        :disabled="isBtn11 ? true : false"
        plain
        @click.prevent="fnLink('/bithumb')"
      >BITHUMB</el-button>
      <el-button
        size="mini"
        :type="isBtn12 ? 'primary' : ''"
        :disabled="isBtn12 ? true : false"
        plain
        @click.prevent="fnLink('/coinone')"
      >COINONE</el-button>
      <el-button
        size="mini"
        :type="isBtn13 ? 'primary' : ''"
        :disabled="isBtn13 ? true : false"
        plain
        @click.prevent="fnLink('/trade_upbit')"
      >UPBIT ..1</el-button>
      <el-button
        size="mini"
        :type="isBtn14 ? 'primary' : ''"
        :disabled="isBtn14 ? true : false"
        plain
        @click.prevent="fnLink('/notice')"
      >NOTICE</el-button>
      <br />
      <el-button
        size="mini"
        :type="isBtn21 ? 'primary' : ''"
        :disabled="isBtn21 ? true : false"
        plain
        @click.prevent="fnLink('/binance_btc')"
      >BINANCE BTC</el-button>
      <el-button
        size="mini"
        :type="isBtn22 ? 'primary' : ''"
        :disabled="isBtn22 ? true : false"
        plain
        @click.prevent="fnLink('/binance_btc_detail')"
      >BINANCE ..1</el-button>
      <el-button
        size="mini"
        :type="isBtn23 ? 'primary' : ''"
        :disabled="isBtn23 ? true : false"
        plain
        @click.prevent="fnLink('/markets')"
        style="background-color:#FFEBEE;"
      >Market Activity</el-button>
      <el-button
        size="mini"
        :type="isBtn24 ? 'primary' : ''"
        :disabled="isBtn24 ? true : false"
        plain
        @click.prevent="fnLink('/trade_bithumb')"
      >BITHUMB ..1</el-button>
    </el-button-group>
    <div class="tCap">
      MARKET ${{TCAP}}
      <span v-html="TPER" />
      <span>BTC</span>
      {{TBTC}}
      <span v-html="TBTCPER" />
    </div>
    <div style="display:block;padding:0 5px;">
      <span style="display:inline; float:left; font-size:9pt;">USD {{usd_naver_top}}</span>
      <a href="/future.html" target="_blank" class="linkNotice"><span style="display:inline; float:right; font-size:9pt;">Binance Future</span></a>
    </div>
    <br/>
  </div>
</template>

<script>
export default {
  name: 'appMenubar',
  data () {
    return {
      isBtn1: false,
      isBtn2: false,
      isBtn3: false,
      isBtn4: false,
      isBtn11: false,
      isBtn12: false,
      isBtn13: false,
      isBtn14: false,
      isBtn21: false,
      isBtn22: false,
      isBtn23: false,
      isBtn24: false,
      TCAP: '',
      TPER: '',
      TBTC: '',
      TBTCPER: '',
      usd_naver_top: ''
    }
  },
  created () {
    this.$root.$refs.MENU = this
    if (window.location.pathname === '/bitfinex') this.isBtn2 = true
    else if (window.location.pathname === '/upbit_krw') this.isBtn3 = true
    else if (window.location.pathname === '/upbit_btc') this.isBtn4 = true
    else if (window.location.pathname === '/bithumb') this.isBtn11 = true
    else if (window.location.pathname === '/coinone') this.isBtn12 = true
    else if (window.location.pathname === '/trade_upbit') this.isBtn13 = true
    else if (window.location.pathname === '/notice') this.isBtn14 = true
    else if (window.location.pathname === '/binance_btc') this.isBtn21 = true
    else if (window.location.pathname === '/binance_btc_detail') this.isBtn22 = true
    else if (window.location.pathname === '/markets') this.isBtn23 = true
    else if (window.location.pathname === '/trade_bithumb') this.isBtn24 = true
    else this.isBtn1 = true
  },
  methods: {
    fnLink: function (e) {
      this.isBtn1 = false
      this.isBtn2 = false
      this.isBtn3 = false
      this.isBtn4 = false
      this.isBtn11 = false
      this.isBtn12 = false
      this.isBtn13 = false
      this.isBtn14 = false
      this.isBtn21 = false
      this.isBtn22 = false
      this.isBtn23 = false
      this.isBtn24 = false
      if (e === '/bitfinex') this.isBtn2 = true
      else if (e === '/upbit_krw') this.isBtn3 = true
      else if (e === '/upbit_btc') this.isBtn4 = true
      else if (e === '/bithumb') this.isBtn11 = true
      else if (e === '/coinone') this.isBtn12 = true
      else if (e === '/trade_upbit') this.isBtn13 = true
      else if (e === '/notice') this.isBtn14 = true
      else if (e === '/binance_btc') this.isBtn21 = true
      else if (e === '/binance_btc_detail') this.isBtn22 = true
      else if (e === '/markets') this.isBtn23 = true
      else if (e === '/trade_bithumb') this.isBtn24 = true
      else this.isBtn1 = true
      this.$router.push(e)
    }
  }
}
</script>

<style scoped>
button {
  width: 83px;
  padding: 6px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar.vue